//--sound
import { SoundProvider, useSound } from './components/sound/soundContext';

//pages
import { PAGES, FOLDERS, getInitialWindowState } from './config/pagesConfig';
import LandingPage from '../src/pages/draggableLanding';
import CollectiblesPage from '../src/pages/collectiblesPage';
import AboutPage from '../src/pages/aboutPage';
import MyWorkPage from './pages/myWorkPage';
import VirtualPetPage from './pages/collections/virtualPets';
import Figurines from './pages/collections/figurines';
import CardThings from './pages/collections/cardThings';
import Squishies from './pages/collections/squishies';
import HairClips from './pages/collections/hairclips';
import BagCharmKeychains from './pages/collections/bagCharmKeychains';
import PortfolioPage from './pages/portfoliolinksPage';
import LinksPage from './pages/linksPage';
import ContactPage from './pages/contactPage';
import OCPage from './pages/ocPage';
import Fun from './pages/fun';
//---dark mode
import sun from './static/images/sun.webp';
import moon from './static/images/moon.webp';
//---noise mode
import noiseOnDay from './static/images/assetComponents/noise/noise day on.png';
import noiseOffDay from './static/images/assetComponents/noise/noise day off.png';
import noiseOnNight from './static/images/assetComponents/noise/noise night on.png';
import noiseOffNight from './static/images/assetComponents/noise/noise night off.png';
//---bunny icon
import bunnyDay from './static/images/assetComponents/bunny/bunny-day-small.webp';
import bunnyNight from './static/images/assetComponents/bunny/bunny-night-small.webp';
import bunnyDayBlink from './static/images/assetComponents/bunny/bunny-day-blink-small.webp';
import bunnyNightBlink from './static/images/assetComponents/bunny/bunny-night-blink-small.webp';
//---flower growing
import flowerDay from './static/images/assetComponents/flower/animatedFlowers/flowerDay.png';
import flowerNight from './static/images/assetComponents/flower/animatedFlowers/flowerNight.png';
import flowerDayAnimated from './static/images/assetComponents/flower/animatedFlowers/flowerGrowDay.gif';
import flowerNightAnimated from './static/images/assetComponents/flower/animatedFlowers/flowerGrowNight.gif';
//---mail icon
import mailDayClosed from './static/images/assetComponents/mail/day-big.png';
import mailDayOpen from './static/images/assetComponents/mail/day-open-big.png';
import mailNightClosed from './static/images/assetComponents/mail/night-big.png';
import mailNightOpen from './static/images/assetComponents/mail/night-open-big.png';
//---fun shortcut icon
import starDay from '../src/static/images/assetComponents/fun_shortcut/day.png';
import starDayH from '../src/static/images/assetComponents/fun_shortcut/day_hover.png';
import starNight from '../src/static/images/assetComponents/fun_shortcut/night.png';
import starNightH from '../src/static/images/assetComponents/fun_shortcut/night_hover.png';
//---who I follow on socials
import eggDay from '../src/static/images/assetComponents/socialsRelated/day.png';
import eggDayH from '../src/static/images/assetComponents/socialsRelated/dayH.png';
import eggNight from '../src/static/images/assetComponents/socialsRelated/night.png';
import eggNightH from '../src/static/images/assetComponents/socialsRelated/nightH.png';
//everything else
import './App.css';
import React, { useState, useEffect } from 'react';
import DraggableWindow from './components/draggableWindow';

function App() {

  const [theme, setTheme] = useState('light');
  const [font, setFont] = useState('pixel');

  const [menuOpen, setMenuOpen] = useState(false);//mobile menu
  const [isBunnyBlinking, setIsBunnyBlinking] = useState(false);
  const [isEnvelopeOpen, setIsEnvelopeOpen] = useState(false);
  const [isFlowerHoveredOver, setIsFlowerHoveredOver] = useState(false);
  const [isStarHoveredOver, setIsStarHoveredOver] = useState(false);
  const [isMouseOnEgg, setIsMouseOnEgg] = useState(false);
  const { isNoiseOn, setIsNoiseOn, playPopSound, playDingSound } = useSound();

  //handle states for window management
  
  const [activeWindows, setActiveWindows] = useState({
    ...getInitialWindowState(),
    [PAGES.LANDING]: false //Show landing page by default (only when you click the bunny)
  });
  //Toggle mobile menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  //nav history
  const [navHistory, setNavHistory] = useState([PAGES.LANDING]);
  //Special case for back button
  const handleBack = () => {
    if (navHistory.length > 1) {
      const newHistory = [...navHistory];
      newHistory.pop(); //Remove current page
      const previousPage = newHistory[newHistory.length - 1];
      setNavHistory(newHistory);
      setActiveWindows({
        ...getInitialWindowState(),//Close all windows
        [previousPage]: true//open previous page
      });
    } else {
      //If only landing page in history, go to landing
      navigateTo(PAGES.LANDING);
    }
  };
  //Toggle between light and dark mode
  const toggleTheme = () => {
    playPopSound();
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  //Toggle between noise and no noise
  const toggleNoise = () => {
    playPopSound();
    setIsNoiseOn(!isNoiseOn); //Toggle the state instead of always setting to true
};
  //Toggle between fonts
  const toggleFont = () => {
    playPopSound();
    const newFont = font === 'pixel' ? 'opendyslexic' : 'pixel';
    setFont(newFont);
    document.documentElement.style.setProperty(
      '--current-font',
      newFont === 'pixel' ? 'var(--pixel-font)' : 'var(--dyslexic-font)'
    );
    document.documentElement.setAttribute('data-font', newFont);
    localStorage.setItem('font', newFont);
  };
  
  //Check for saved theme preference on component mount
  useEffect(() => {
    // Preload sound
    new Audio(require('./static/sounds/pop_463390__vilkas_sound__vs-pop_2.mp3')).load();
    //Preload animated images
    const preloadImages = [flowerDayAnimated, flowerNightAnimated];
    preloadImages.forEach(src => {
      const img = new Image();
      img.src = src;
    });

    const savedTheme = localStorage.getItem('theme') || 'light';
    const savedFont = localStorage.getItem('font') || 'pixel';
    
    setTheme(savedTheme);
    setFont(savedFont);
    
    document.documentElement.setAttribute('data-font', savedFont);
    document.documentElement.setAttribute('data-theme', savedTheme);
    document.documentElement.style.setProperty(
      '--current-font',
      savedFont === 'pixel' ? 'var(--pixel-font)' : 'var(--dyslexic-font)'
    );
  }, []);
  
  //Unified navigation handler
  const navigateTo = (page) => {
    playPopSound();
    console.log(`Navigating to ${page}`);
    setNavHistory(prev => [...prev, page]);
    setActiveWindows({
      ...getInitialWindowState(),//reset all windows to false
      [page]: true //open requested page    
    });
  };
  console.log('Active pages:', Object.entries(activeWindows).filter(([_, isActive]) => isActive));
  //handle bunny click handler
  const handleBunnyClick = () => {
    playPopSound();
    console.log('Bunny clicked, navigating to landing');
    setIsBunnyBlinking(true);
    navigateTo(PAGES.LANDING);
    setTimeout(() => setIsBunnyBlinking(false), 300);
  };
  //handle star click handler
  const handleStarClick = () => {
    playDingSound();
    setIsStarHoveredOver(true);
    navigateTo(PAGES.FUN);
    setTimeout(() => setIsStarHoveredOver(false), 300);
  }
  //handle envelope click handler
  const handleEnvelopeClick = () => {
    playPopSound();
    console.log('Mail clicked, navigating to contact');
    setIsEnvelopeOpen(true);
    navigateTo(PAGES.CONTACT);
    setTimeout(() => setIsEnvelopeOpen(false), 300);
  }
  //handle socials website link
  const handleEggWebsiteClick = () => {
    playPopSound();
    setIsMouseOnEgg(true);
    navigateTo(PAGES.WORK);
    setTimeout(() => setIsMouseOnEgg(false), 300);
  }
  //Render DraggableWindow for active page
  const renderActiveWindow = () => {
    const activePages = Object.entries(activeWindows)
      .filter(([_, isActive]) => isActive)
      .map(([page]) => page);

      console.log('Rendering active window:', activePages);

    if (activePages.length === 0) return null;

    const page = activePages[0]; //Only one window active at a time
    const commonProps = {
      theme,
      onClose: () => setActiveWindows(getInitialWindowState()),
      onBackClick: handleBack
    };

    switch (page) {
      case PAGES.LANDING:
        return (
          <DraggableWindow 
            title="Hello! I'm Anh"
            theme={theme}
            onClose={() => setActiveWindows(getInitialWindowState())}
          >
            <LandingPage 
              theme={theme} 
              folders={FOLDERS.MAIN}
              onFolderClick={navigateTo}
            />
          </DraggableWindow>
        );
      case PAGES.ABOUT:
        return (
          <DraggableWindow title="About Me" {...commonProps}>
            <AboutPage theme={theme} onBackClick={handleBack}/>
          </DraggableWindow>
        );
      case PAGES.COLLECTIBLES:
        return (
          <DraggableWindow title="My Collectibles" {...commonProps}>
            <CollectiblesPage 
              theme={theme}
              onBackClick={handleBack}
              folders={FOLDERS.COLLECTIBLES}
              onFolderClick={navigateTo}
            />
          </DraggableWindow>
        );
      case PAGES.WORK:
        return (
          <DraggableWindow title="My Work" {...commonProps}>
            <MyWorkPage 
            theme={theme}
            folders={FOLDERS.WORK}
            onFolderClick={navigateTo}
            />
          </DraggableWindow>
        );
      case PAGES.VIRTUAL_PETS:
        return (
          <DraggableWindow title="Virtual Pet Collection" {...commonProps}>
            <VirtualPetPage theme={theme} />
          </DraggableWindow>
        );
      case PAGES.CARD_THINGS:
        return (
          <DraggableWindow title="Card Things Collection" {...commonProps}>
            <CardThings theme={theme} />
          </DraggableWindow>
        );
      case PAGES.FIGURINES:
        return (
          <DraggableWindow title="Figurine Collection" {...commonProps}>
            <Figurines theme={theme} />
          </DraggableWindow>
        );
      case PAGES.SQUISHIES:
        return (
          <DraggableWindow title="Squishy Collection" {...commonProps}>
            <Squishies theme={theme} />
          </DraggableWindow>
        );
      case PAGES.HAIRCLIPS:
        return (
          <DraggableWindow title="Hairclip Collection" {...commonProps}>
            <HairClips theme={theme} />
          </DraggableWindow>
        );
      case PAGES.BAGCHARMKEYCHAINS:
        return (
          <DraggableWindow title="Bag Charms & Keychains" {...commonProps}>
            <BagCharmKeychains theme={theme} />
          </DraggableWindow>
        );
      case PAGES.PORTFOLIO:
        return (
          <DraggableWindow title="Portfolio" {...commonProps}>
            <PortfolioPage theme={theme} />
          </DraggableWindow>
        );
      case PAGES.LINKS:
        return (
          <DraggableWindow title="Links" {...commonProps}>
            <LinksPage theme={theme} />
          </DraggableWindow>
        );
      case PAGES.FUN:
        return (
          <DraggableWindow title="What I do for fun" {...commonProps}>
            <Fun 
              theme={theme}
              onBackClick={handleBack}
              folders={FOLDERS.FUN}
              onFolderClick={navigateTo} 
            />
          </DraggableWindow>
        );
      case PAGES.CONTACT:
        return (
          <DraggableWindow title="Contact" {...commonProps}>
            <ContactPage theme={theme} />
          </DraggableWindow>
        );
      case PAGES.OC:
        return (
          <DraggableWindow title="My Original Characters" {...commonProps}>
            <OCPage theme={theme} />
          </DraggableWindow>
        )
      //Add pages
      default:
        return null;
    }
  };
  //handle hover    
  return (
    <div className="App">
    <button className="mobile-menu-button" onClick={toggleMenu}>
      ☰
    </button>
    
    <div className={`switchToggles ${menuOpen ? 'open' : ''}`}>
      <button onClick={toggleTheme} className="theme-toggle">
        <img
          src={theme === 'light' ? sun : moon}
          alt={theme === 'light' ? 'Light mode' : 'Dark mode'} 
          className='themeIcon'
        />
      </button>
      <button onClick={toggleNoise} className="noise-toggle">
        <img
          src={
            isNoiseOn
            ? (theme === 'light' ? noiseOnDay : noiseOnNight)
            : (theme === 'light' ? noiseOffDay : noiseOffNight)
          }
          alt={isNoiseOn? 'noise on': 'noise off'}
          className="noiseIcon"
        />
      </button>
      <button onClick={toggleFont} className="font-toggle">
        {font === 'pixel' ? 'Switch to OpenDyslexic' : 'Switch to Pixelify'}
      </button>
    </div>

    <header className="App-header">
      <div className='main-left'>
        <img src={
          isEnvelopeOpen
          ? (theme === 'light' ? mailDayOpen : mailNightOpen)
          : (theme === 'light' ? mailDayClosed : mailNightClosed)
        }
        className="mailClick" 
          alt="clickable mail"
          onMouseEnter={() => setIsEnvelopeOpen(true)}
          onMouseLeave={() => setIsEnvelopeOpen(false)}
          onClick={ (e)=>{
            e.stopPropagation();//prevent event bubbling
            handleEnvelopeClick();
          }}
        />
        <img src={
          isMouseOnEgg
          ? (theme === 'light' ? eggDayH : eggNightH)
          : (theme === 'light' ? eggDay : eggNight)
        }
        className="webLinkClick"
        alt="clickable link1"
        onMouseEnter={()=> setIsMouseOnEgg(true)}
        onMouseLeave={()=> setIsMouseOnEgg(false)}
        onClick={ (e)=>{
          e.stopPropagation();//prevent event bubbling
          handleEggWebsiteClick();
        }}
        />
      </div>
      <div className="main-middle">
        <h1>Click Me</h1>
        <div className="downArrow"></div>
        <img 
          src={
            isBunnyBlinking 
            ? (theme === 'light' ? bunnyDayBlink : bunnyNightBlink)
            : (theme === 'light' ? bunnyDay : bunnyNight)
          } 
          className="bunnyClick" 
          alt="clickable bunny"
          onMouseEnter={() => setIsBunnyBlinking(true)}
          onMouseLeave={() => setIsBunnyBlinking(false)}
          onClick={(e) => {
            e.stopPropagation()//prevent event bubbling
            handleBunnyClick();
          }}
        />
      </div>
      <div className='main-right'>
        <img
          src={
            isStarHoveredOver
            ? (theme === 'light' ? starDayH : starNightH)
            : (theme === 'light' ? starDay : starNight)
          }
          className='funClick'
          alt='fun-stuff-shortcut'
          onMouseEnter={() => setIsStarHoveredOver(true)}
          onMouseLeave={() => setIsStarHoveredOver(false)}
          onClick={ (e)=>{
            e.stopPropagation();//prevent event bubbling
            handleStarClick();
          }}
        />
        <img
          src={
            isFlowerHoveredOver
            ? (theme === 'light' ? flowerDayAnimated : flowerNightAnimated)
            : (theme === 'light' ? flowerDay : flowerNight)
          }
          className="flower-placement"
          alt="decorative flower"
          onMouseEnter={() => setIsFlowerHoveredOver(true)}
          //small delay for flower animtion to complete
          onMouseLeave={() => {
            setTimeout(() => setIsFlowerHoveredOver(false), 1000);
          }}
        />
      </div>
    </header>
    
    {renderActiveWindow()}
  </div>
  );
}

export default App;
